var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    fill: "none",
    viewBox: "0 0 34 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "section_svg__a",
    width: 34,
    height: 21,
    x: 0,
    y: 0,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-7.86a4 4 0 0 0-3.328 1.781L17 20l-.813-1.219A4 4 0 0 0 12.86 17H5a4 4 0 0 1-4-4V5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0087CF",
    d: "M1 5a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-7.86a4 4 0 0 0-3.328 1.781L17 20l-.813-1.219A4 4 0 0 0 12.86 17H5a4 4 0 0 1-4-4V5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 20-.832.555a1 1 0 0 0 1.664 0L17 20zm.813-1.219-.832-.554.831.554zm-1.625 0 .832-.554-.832.554zM5 2h24V0H5v2zm27 3v8h2V5h-2zM2 13V5H0v8h2zm15.832 6.445-.813-1.218-1.664 1.109.813 1.219 1.664-1.11zM12.86 16H5v2h7.86v-2zM29 16h-7.86v2H29v-2zm-12.02 2.227-.812 1.218 1.664 1.11.813-1.22-1.665-1.108zM21.14 16a5 5 0 0 0-4.16 2.227l1.665 1.109A3 3 0 0 1 21.14 18v-2zM0 13a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3H0zm32 0a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2zM29 2a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2zM17.02 18.227A5 5 0 0 0 12.86 16v2a3 3 0 0 1 2.495 1.336l1.665-1.11zM5 0a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3V0z",
    mask: "url(#section_svg__a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.54644716aabb998a390623cadbcf7937.svg";
export { ForwardRef as ReactComponent };